import * as arquivo from '@/api/arquivo'

const state = {
}

const mutations = { }

const actions = {
  add: function ({ commit }, dados) {
    try {
      return arquivo.add(dados)
    } catch (e) {
      return e
    }
  },
  del: function ({ commit }, id) {
    try {
      return arquivo.del(id)
    } catch (e) {
      return e
    }
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/arquivo.js